module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Solicitações'
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (Object.keys(_vm.parcelaSelecionada).length > 0) ? _c('div', {
    staticClass: "row-flex all-start prest-button-container"
  }, [(!_vm.loading.show) ? _c('span', [_c('g-button-moema', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading.show && _vm.totalPorcentagem >= 80 && _vm.usuarioLogado.userType == 'ENTIDADE' && _vm.chiefActive()),
      expression: "!loading.show && totalPorcentagem >= 80 && usuarioLogado.userType == 'ENTIDADE' && chiefActive()"
    }]
  }, [_c('g-button-moema', {
    attrs: {
      "color": "success",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.concluir()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")])], 1), _vm._v(" "), (!_vm.loading.show && _vm.usuarioLogado.userType == 'ENTIDADE' && !_vm.chiefActive() && _vm.totalPorcentagem >= 80) ? _c('span', [_vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  })]) : _vm._e(), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1), _vm._v(" "), (_vm.loading.show) ? _c('div', {
    staticClass: "overlay-loading"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v("\n     [" + _vm._s(_vm.mensagemLoading) + "]\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.loading.show) ? _c('div', {
    staticClass: "column start-centered prest-section-container"
  }, [(_vm.mensagemAviso.length > 0) ? _c('div', {
    staticClass: "column all-start prest-main-container-ged"
  }, _vm._l((_vm.mensagemAviso), function(aviso) {
    return _c('div', {
      key: aviso,
      staticClass: "row-flex centered-start prest-declaracoes-container-aviso"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(aviso) + "\n        ")])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column all-start prest-main-container-ged"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "prest-box-title row-flex centered-start"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n            " + _vm._s(_vm.dadosComplementares.numeroProjeto) + " - " + _vm._s(_vm.dadosComplementares.projeto) + "\n            "), (_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.loading.tela) ? _c('span', [_vm._v("\n              ("), _c('strong', [_vm._v(_vm._s(_vm.dadosComplementares.statusERP))]), _vm._v(")\n              "), _c('router-link', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'small',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'small', arrow : true }"
    }],
    attrs: {
      "title": '<h5>Ir para a página do Projeto</h5>',
      "to": {
        name: 'projeto',
        params: {
          numero: _vm.dadosComplementares.numeroProjeto
        }
      },
      "target": "_blank"
    }
  }, [_vm._v(" "), _c('i', {
    staticClass: "fa fa-external-link"
  })])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "column start-centered prest-entidade-info-container"
  }, [_c('router-link', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    attrs: {
      "title": '<h5>Ir para o Cadastro dessa Entidade</h5>',
      "to": {
        name: 'cadastro-entidade-visualiza',
        params: {
          id: _vm.dadosComplementares.fk_entidade
        }
      },
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.dadosComplementares.nome_entidade) + "  "), _c('i', {
    staticClass: "fa fa-external-link"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-start prest-label-info"
  }, [_c('b', [_vm._v("Período de execução:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.dadosComplementares.data_inicial) + " a " + _vm._s(_vm.dadosComplementares.data_final))])]), _vm._v(" "), _c('div', {
    staticClass: "row-flex centered-start prest-label-info"
  }, [_c('b', [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("cnpj")(_vm.dadosComplementares.cnpj_entidade)))])]), _vm._v(" "), (_vm.usuarioLogado.userType == 'FUNDACAO') ? _c('div', {
    staticClass: "row-flex centered-start prest-label-info"
  }, [_c('b', [_vm._v("Projeto Superior:")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.dadosComplementares.ds_projeto_superior))])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column all-start prest-main-container-ged"
  }, [_vm._m(3), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parcelaSelecionada),
      expression: "parcelaSelecionada"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "projeto",
      "aria-hidden": "true"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.parcelaSelecionada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.buscaDados()
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": ""
    },
    domProps: {
      "value": []
    }
  }, [_vm._v("Selecione a Parcela de Adiantamento")]), _vm._v(" "), _vm._l((_vm.parcelasAdiantamento), function(parcelaAdiantamento) {
    return _c('option', {
      domProps: {
        "value": parcelaAdiantamento
      }
    }, [_vm._v("Parcela " + _vm._s(parcelaAdiantamento.parcela) + " - Valor Adiantado: " + _vm._s(_vm._f("real")(parcelaAdiantamento.valor_parcela)) + " (" + _vm._s(parseFloat(parcelaAdiantamento.valor_gravado * 100 / parcelaAdiantamento.valor_parcela).toFixed()) + "% comprovado)")])
  })], 2)]), _vm._v(" "), (Object.keys(_vm.parcelaSelecionada).length > 0) ? _c('div', {
    staticClass: "column all-start prest-main-container-ged"
  }, [(_vm.loading.documentos) ? _c('div', {
    staticClass: "overlay-loading"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v("\n        [" + _vm._s(_vm.mensagemLoading) + "]\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.loading.documentos) ? _c('div', {
    staticClass: "column all-start prest-w-100"
  }, [_c('cronogramaGED', {
    ref: "cronograma",
    attrs: {
      "cronograma": _vm.cronograma,
      "setNota": _vm.setNota,
      "dataInicioSapiens": _vm.dadosComplementares.data_inicio_sapiens,
      "dataInicial": _vm.dadosComplementares.data_inicial,
      "dataFinal": _vm.dadosComplementares.data_final,
      "idEntidade": _vm.dadosComplementares.fk_entidade,
      "cnpjEntidade": _vm.dadosComplementares.cnpj_entidade,
      "fkPrestacaoSimplificada": _vm.parcelaSelecionada.id,
      "notasCadastradas": _vm.notasCadastradas,
      "acertoValoresCancelamentoEdicaoCronograma": _vm.acertoValoresCancelamentoEdicaoCronograma
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "column end-centered prest-total-container"
  }, [_c('div', [_vm._v("\n            Total Registrado: "), _c('b', [_vm._v(_vm._s(_vm._f("real")(_vm.parcelaSelecionada.valor_gravado)))])]), _vm._v(" "), _c('div', [_vm._v("\n            Total Pendente: "), _c('b', [_vm._v(_vm._s(_vm._f("real")(parseFloat(_vm.parcelaSelecionada.valor_parcela) - parseFloat(_vm.parcelaSelecionada.valor_gravado))) + " ")])]), _vm._v(" "), (_vm.existeProcesso.length > 0) ? _c('div', {
    staticClass: "column end-centered prest-total-container-processo"
  }, [_c('div', [_vm._v("\n              Total em Processo de Baixa/Baixado: "), _c('b', {
    staticStyle: {
      "font-size": "2rem"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalProcesso)))])]), _vm._v(" "), _c('div', [_vm._v("\n              Total registrado pendente de Baixa: "), _c('b', {
    staticStyle: {
      "color": "#FF9900",
      "font-size": "2rem"
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totalSemProcesso)))])])]) : _vm._e(), _vm._v(" "), _c('b-progress', {
    staticClass: "prest-progress-bar",
    attrs: {
      "max": 100,
      "animated": true
    }
  }, [_c('b-progress-bar', {
    staticClass: "prest-progress-bar-internal",
    class: _vm.totalPorcentagem >= 80 ? 'prest-progress-valid' : '',
    attrs: {
      "value": _vm.totalPorcentagem,
      "max": 100,
      "animated": true
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.totalPorcentagem) + "%")])])], 1), _vm._v(" "), _vm._m(4)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading.documentos) ? _c('div', {
    staticClass: "box-body prest-notas-cadastradas-container"
  }, [_c('div', {
    staticClass: "row-flex start-between"
  }, [_vm._m(5), _vm._v(" "), (_vm.usuarioLogado.userType == 'FUNDACAO') ? _c('div', {
    staticClass: "row-flex all-ceentered prest-action-notas-container"
  }, [_c('download-excel', {
    attrs: {
      "data": _vm.formattedItems,
      "meta": _vm.excelMeta,
      "fields": _vm.excelCampos.basico,
      "type": "xls",
      "name": ((_vm.moment().format('DDMMYYYYhhmmss')) + " Documentos Fiscais " + (_vm.dadosComplementares.numeroProjeto) + "(Parcela Adiantamento " + (_vm.parcelaSelecionada.parcela) + ").xls")
    }
  }, [_c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: false,
        followCursor: true,
        theme: 'light'
      }),
      expression: "{ arrow: false, followCursor: true, theme: 'light' }"
    }],
    attrs: {
      "color": "success",
      "size": "button--size-ss",
      "title": '<h5> Baixar Planilha com os Documentos Cadastrados </h5>'
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: false,
        followCursor: true,
        theme: 'light'
      }),
      expression: "{ arrow: false, followCursor: true, theme: 'light' }"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "title": '<h5> Baixar Todos os Anexos </h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onDownloadZIP()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-download",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    key: _vm.tableDataKey,
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "fields": _vm.table.fields,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "filter": _vm.table.filter,
      "empty-text": "Nenhum registro encontrado",
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "data_emissao_documento",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "valor_documento",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("real")(row.value)))]
      }
    }, {
      key: "serie_documento",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value.replace('_', ' ')))]
      }
    }, {
      key: "item",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value))]
      }
    }, {
      key: "fornecedor_cpf_cnpj",
      fn: function(row) {
        return [(row.value.length < 12) ? _c('span', [_vm._v(_vm._s(_vm._f("cpf")(row.value)))]) : _c('span', [_vm._v(_vm._s(_vm._f("cnpj")(row.value)))])]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [(!_vm.editandoNota) ? _c('div', {
          staticClass: "row-flex all-centered prest-button-row"
        }, [_c('g-button-ujarak', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              arrow: false,
              followCursor: true,
              theme: 'light'
            }),
            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
          }],
          attrs: {
            "color": "success",
            "size": "button--size-ss",
            "title": '<h5> Detalhar Documento </h5>'
          },
          nativeOn: {
            "click": function($event) {
              return _vm.toggleDetalheNota(true, row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search",
          attrs: {
            "aria-hidden": "true"
          }
        })]), _vm._v(" "), (_vm.usuarioLogado.userType == 'ENTIDADE' && (!row.item.hasOwnProperty('fk_processo') || _vm._.isNull(row.item.fk_processo))) ? _c('g-button-ujarak', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              arrow: false,
              followCursor: true,
              theme: 'light'
            }),
            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
          }],
          attrs: {
            "color": "primary",
            "size": "button--size-ss",
            "title": '<h5> Editar Documento </h5>'
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editarNota(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType == 'ENTIDADE' && (!row.item.hasOwnProperty('fk_processo') || _vm._.isNull(row.item.fk_processo))) ? _c('g-button-ujarak', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              arrow: false,
              followCursor: true,
              theme: 'light'
            }),
            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
          }],
          attrs: {
            "color": "error",
            "size": "button--size-ss",
            "title": "'<h5> Excluir Documento </h5>'"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.excluirNota(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _vm._e(), _vm._v(" "), (row.item.fk_processo && _vm.usuarioLogado.userType == 'ENTIDADE') ? _c('div', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              arrow: false,
              followCursor: true,
              theme: 'light'
            }),
            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
          }],
          staticClass: "prest-label-info-button",
          attrs: {
            "title": '<h5> Documentos vinculados a um processo de baixa não podem ser editados ou excluídos. </h5>'
          }
        }, [_c('i', {
          staticClass: "fa fa-exclamation-circle",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Baixa de título: " + _vm._s(row.item.fk_processo) + "\n                          ")]) : _vm._e()], 1) : _c('div', {
          staticClass: "column all-centered prest-button-row"
        }, [_c('div', {
          staticClass: "prest-label-info-button"
        }, [_vm._v("\n                            Nota em Edição\n                          ")])])]
      }
    }, {
      key: "status",
      fn: function(row) {
        return [_c('span', {
          class: _vm.getClassStatus(row.value)
        }, [_c('b', [_vm._v(_vm._s(row.value))])])]
      }
    }, {
      key: "anexos",
      fn: function(row) {
        return [_c('div', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              arrow: false,
              followCursor: true,
              theme: 'light'
            }),
            expression: "{ arrow: false, followCursor: true, theme: 'light' }"
          }],
          staticClass: "row-flex all-centered prest-anexo-container",
          attrs: {
            "title": '<h5> Clique para ver os Anexos </h5>'
          },
          on: {
            "click": function($event) {
              return _vm.toggleAnexos(true, row.value)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-paperclip",
          attrs: {
            "aria-hidden": "true"
          }
        })])]
      }
    }], null, false, 1863037478)
  }), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-end prest-total-documentos"
  }, [_c('div', [_vm._v("\n                    Total de Documentos: "), _c('b', [_vm._v(_vm._s(_vm.table.items.length))])])]), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-end prest-total-container"
  }, [_c('div', [_vm._v("\n                    Total Registrado: "), _c('b', [_vm._v(_vm._s(_vm._f("real")(_vm.parcelaSelecionada.valor_gravado)))]), _vm._v(" (" + _vm._s(_vm.totalPorcentagem) + "%)\n                ")])])], 1), _vm._v(" "), (_vm.mostrarAnexos) ? _c('div', {
    staticClass: "column all-centered prest-modal",
    on: {
      "click": function($event) {
        return _vm.toggleAnexos(false)
      }
    }
  }, [_c('div', {
    staticClass: "column all-start prest-content-modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._l((_vm.anexosNotaModal), function(anexo) {
    return _c('a', {
      key: anexo.id,
      staticClass: "prest-modal-link",
      on: {
        "click": function($event) {
          return _vm.downloadAnexo(anexo)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" [" + _vm._s(_vm._f("moment")(anexo.dt_criado, 'DD/MM/YYYY HH:mm')) + "] " + _vm._s(anexo.ds_nome_arquivo) + " \n              ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.mostrarDetalheNota) ? _c('div', {
    staticClass: "column all-centered prest-modal",
    on: {
      "click": function($event) {
        return _vm.toggleDetalheNota(false)
      }
    }
  }, [_c('div', {
    staticClass: "column all-start prest-content-modal-detalhes",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._m(8), _vm._v(" "), _c('ul', [_c('li', [_c('strong', [_vm._v("Número do Documento:")]), _vm._v(" " + _vm._s(_vm.detalhesNotaModal.numero_documento))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Série do Documento:")]), _vm._v(" " + _vm._s(_vm.detalhesNotaModal.serie_documento.replace('_', ' ')))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Data de Emissão:")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.detalhesNotaModal.data_emissao_documento, 'DD/MM/YYYY HH:mm')))]), _vm._v(" "), (_vm.detalhesNotaModal.data_validade_documento) ? _c('li', [_c('strong', [_vm._v("Data de Validade:")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.detalhesNotaModal.data_validade_documento, 'DD/MM/YYYY HH:mm')))]) : _vm._e(), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Valor do Documento:")]), _vm._v(" " + _vm._s(_vm._f("real")(_vm.detalhesNotaModal.valor_documento)))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Tipo de Fornecedor:")]), _vm._v(" " + _vm._s(_vm.detalhesNotaModal.fornecedor_tipo))]), _vm._v(" "), (_vm.detalhesNotaModal.fornecedor_tipo == 'Pessoa Jurídica') ? _c('li', [_c('strong', [_vm._v("CNPJ do Fornecedor:")]), _vm._v(" " + _vm._s(_vm._f("cnpj")(_vm.detalhesNotaModal.fornecedor_cpf_cnpj)))]) : _vm._e(), _vm._v(" "), (_vm.detalhesNotaModal.fornecedor_tipo == 'Pessoa Física') ? _c('li', [_c('strong', [_vm._v("CPF do Fornecedor:")]), _vm._v(" " + _vm._s(_vm._f("cpf")(_vm.detalhesNotaModal.fornecedor_cpf_cnpj)))]) : _vm._e(), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Nome do Fornecedor:")]), _vm._v(" " + _vm._s(_vm.detalhesNotaModal.fornecedor_nome))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Endereço do Fornecedor:")]), _vm._v(" " + _vm._s(_vm.detalhesNotaModal.fornecedor_endereco))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("CEP do Fornecedor:")]), _vm._v(" " + _vm._s(_vm.detalhesNotaModal.fornecedor_cep))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Item:")]), _vm._v(" " + _vm._s(_vm.detalhesNotaModal.item))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Item Cronograma:")]), _vm._v(" "), _c('i', {
    staticStyle: {
      "color": "#6495ED"
    }
  }, [_vm._v("[#" + _vm._s(_vm.detalhesNotaModal.fk_item_cronograma) + "]")]), _vm._v(" " + _vm._s(_vm.detalhesNotaModal.item_cronograma))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Gravado em:")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.detalhesNotaModal.created_at, 'DD/MM/YYYY HH:mm')))]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Atualizado em:")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.detalhesNotaModal.updated_at, 'DD/MM/YYYY HH:mm')))])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._l((_vm.detalhesNotaModal.anexos), function(anexo) {
    return _c('a', {
      key: anexo.id,
      staticClass: "prest-modal-link",
      on: {
        "click": function($event) {
          return _vm.downloadAnexo(anexo)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" [" + _vm._s(_vm._f("moment")(anexo.dt_criado, 'DD/MM/YYYY HH:mm')) + "] " + _vm._s(anexo.ds_nome_arquivo) + " \n              ")])
  })], 2)]) : _vm._e()], 1) : _vm._e()]) : _c('div', {
    staticClass: "column all-start prest-main-container-ged"
  }, [_vm._m(10)]), _vm._v(" "), _c('div', {
    staticClass: "column all-start prest-main-container-ged"
  }, [_c('AnexosComplementares', {
    attrs: {
      "dadosComplementares": _vm.dadosComplementares
    }
  }), _vm._v(" "), (Object.keys(_vm.parcelaSelecionada).length > 0) ? _c('PrestacaoDeclaracoes', {
    ref: "prestacaoDeclaracoes",
    attrs: {
      "dadosComplementares": _vm.dadosComplementares,
      "idPrestacao": _vm.parcelaSelecionada.id,
      "parcelaSelecionada": _vm.parcelaSelecionada,
      "infoParcelasAdiantamento": _vm.infoParcelasAdiantamento
    }
  }) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType == 'FUNDACAO') ? _c('PrestacaoHistorico') : _vm._e()], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Prestação de Contas | Gerenciador de Documentos Fiscais")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-flex centered-start prest-declaracoes-container-aviso-small"
  }, [_c('div', {
    staticClass: "column all-centered prest-declaracoes-icon"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("\n            Aviso: Já é possível solicitar a "), _c('b', [_vm._v("baixa do título de adiantamento")]), _vm._v(". "), _c('i', [_vm._v("*Apenas "), _c('b', [_vm._v("representantes legais")]), _vm._v(" podem concluir a prestação de contas.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column all-centered prest-declaracoes-icon"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "prest-box-title row-flex centered-start"
  }, [_vm._v("Selecione a Parcela de Adiantamento para Vinculação dos Documentos "), _c('i', {
    staticClass: "fa fa-dollar",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', [_vm._v("*Ao chegar a 80% de comprovação, será possível encaminhar a prestação de contas para a Fundação Banco do Brasil, ciente de que o processo de prestação de contas deverá continuar até que se alcance 100% do recurso adiantado.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "prest-box-title row-flex centered-start"
  }, [_vm._v("Documentos Cadastrados "), _c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "prest-box-title row-flex centered-start"
  }, [_vm._v("Detalhe dos Anexos: "), _c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_vm._v("Clique no link para fazer o "), _c('b', [_vm._v("download")]), _vm._v(" do anexo:")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "prest-box-title row-flex centered-start"
  }, [_vm._v("Detalhe do Documento Fiscal: "), _c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', [_vm._v("Clique no link para fazer o "), _c('b', [_vm._v("download")]), _vm._v(" do anexo:")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-flex centered-start prest-declaracoes-container-aviso"
  }, [_c('div', {
    staticClass: "column all-centered prest-declaracoes-icon"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("\n          Selecione uma parcela de Adiantamento para carregar os documentos fiscais vinculados.\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0da2881e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/prestacaoContasSimplificado/PrestacaoSimplificadaGED.vue
// module id = 1796
// module chunks = 2